import { ChangeDetectionStrategy, Component, effect, input, model, signal, ViewEncapsulation } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25IconComponent } from "../s25-icon/s25.icon.component";

@TypeManagerDecorator("s25-ng-fading-success-msg")
@Component({
    selector: "s25-ng-fading-success-msg",
    template: `
        <div class="success-msg" [class.show-msg]="isVisible()" role="status" aria-live="polite">
            @if (message?.()) {
                <s25-ng-icon [type]="'check'" [ariaLabel]="false" />
                <span class="c-margin-left--quarter">{{ message() }}</span>
            }
        </div>
    `,
    host: {
        "[class.has-message]": "isVisible()",
    },
    styles: `
        .success-msg {
            opacity: 0;
            transition: opacity 0.5s ease-out;
            color: var(--color--text-success);
        }

        .success-msg span {
            position: relative;
            top: 2px;
        }

        .show-msg {
            opacity: 1;
        }
    `,
    imports: [S25IconComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
})
export class S25FadingSuccessMsgComponent {
    readonly message = model<string>("");
    readonly durationInMS = input<number>(3000);

    isVisible = signal<boolean>(false);

    constructor() {
        effect((onCleanup) => {
            const msg = this.message?.();
            if (!msg) return;

            this.isVisible.set(true);

            const fadeTimeout = setTimeout(() => {
                this.isVisible.set(false);
            }, this.durationInMS());

            const displayTimeout = setTimeout(() => {
                this.message.set("");
            }, this.durationInMS() + 500);

            onCleanup(() => {
                clearTimeout(fadeTimeout);
                clearTimeout(displayTimeout);
            });
        });
    }
}
